import {MainToolbar} from './main-toolbar';

export function ToolbarContainer() {
  return (
    <div
      id="pixpen-toolbar"
      data-testid="pixpen-toolbar"
      data-element="main-toolbar"
    >
      <MainToolbar />
    </div>
  );
}
